export function convertIntObj<T extends object, K extends keyof T>(
  obj: T,
  keys: K[]
): Record<string, number> {
  return Object.entries(obj).reduce(
    (acc, [k, v]) => {
      if (keys.includes(k as any)) {
        acc[k] = Number(v);
      } else {
        acc[k] = v;
      }

      return acc;
    },
    {} as Record<string, number>
  );
}

/**
 * Returns an array of the given object's own enumerable property values.
 * It is like Object.keys() but with type safety.
 */
export const objectKeys = <Obj extends object>(obj: Obj): (keyof Obj)[] => {
  return Object.keys(obj) as (keyof Obj)[];
};

/**
 * Return an array of the given object's own enumerable property values.
 * It is like Object.values() but with type safety.
 */
export const objectValues = <Obj extends object>(obj: Obj): Obj[keyof Obj][] => {
  return Object.values(obj) as Obj[keyof Obj][];
};

/**
 * Return an array of the given object's own enumerable property values.
 * It is like Object.entries() but with type safety.
 */
export const objectEntries = <Obj extends object>(obj: Obj): [keyof Obj, Obj[keyof Obj]][] => {
  return Object.entries(obj) as [keyof Obj, Obj[keyof Obj]][];
};
